export default __webpack_public_path__ + "static/media/paloateparo1.6315765a.jpg";